/**
 * Utility module for object-related functions
 *
 */

/**
 * This is emulate the _.isMatch function from lodash
 *
 * @param {Ti} object
 * @param {*} source
 * @returns
 */
const isMatch = (object, source) => {
  if (object === null || object === undefined || source === null || source === undefined) {
    return object === source;
  }

  if (typeof object !== 'object' || typeof source !== 'object') {
    return object === source;
  }

  const sourceKeys = Object.keys(source);

  for (let i = 0; i < sourceKeys.length; i++) {
    const key = sourceKeys[i];
    const sourceValue = source[key];
    const objectValue = object[key];

    if (typeof sourceValue === 'object' && sourceValue !== null) {
      if (!isMatch(objectValue, sourceValue)) {
        return false;
      }
    } else if (objectValue !== sourceValue) {
      return false;
    }
  }

  return true;
};

/**
 * This is emulate the _.omitBy function from lodash
 *
 * @param {Ti} object
 * @param {*} source
 * @returns
 */
const omitBy = (object, predicate) => {
  if (object === null || object === undefined || typeof object !== 'object') {
    return {};
  }

  const result = {};
  const keys = Object.keys(object);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = object[key];

    if (!predicate(value, key, object)) {
      result[key] = value;
    }
  }

  return result;
};

/**
 * This is emulate the _.isNil function from lodash
 *
 * @param {any} value
 * @returns {boolean}
 */
const isNil = (value) => value === null || value === undefined;

export { isMatch, isNil, omitBy };
